import e from "compute-scroll-into-view";
var t = function t(e) {
  return !1 === e ? {
    block: "end",
    inline: "nearest"
  } : function (e) {
    return e === Object(e) && 0 !== Object.keys(e).length;
  }(e) ? e : {
    block: "start",
    inline: "nearest"
  };
};
function o(o, l) {
  var n = o.isConnected || o.ownerDocument.documentElement.contains(o);
  if (function (e) {
    return "object" == typeof e && "function" == typeof e.behavior;
  }(l)) return l.behavior(n ? e(o, l) : []);
  if (!n) return;
  var r = t(l),
    c = e(o, r),
    i = ("scrollBehavior" in document.body.style);
  c.forEach(function (e) {
    var t = e.el,
      o = e.top,
      l = e.left;
    t.scroll && i ? t.scroll({
      top: o,
      left: l,
      behavior: r.behavior
    }) : (t.scrollTop = o, t.scrollLeft = l);
  });
}
export { o as default };